const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const parseDate = (str) => {
  const date = new Date(str)
  return date.getDate() + ' ' + months[date.getMonth()]
}

export const categorizePosts = (posts) => {
  const categorizedPosts = {}
  posts?.forEach((p) => {
    p.metadata?.category.forEach((c) => {
      categorizedPosts[c.slug] = categorizedPosts[c.slug]
        ? [...categorizedPosts[c.slug], p]
        : [p]
    })
  })
  return categorizedPosts
}

const includesCategory = (post, mapCategories) => {
  for (let i = 0; i < post?.metadata?.category?.length; i++) {
    if (mapCategories[post?.metadata?.category[i].slug]) return true
  }

  return false
}

export const getRelatedPosts = (post, posts) => {
  // Posts to exclude from related posts
  const filter = [
    post?.slug,
    ...(post?.metadata?.related_posts ?? []).map((p) => p.slug),
  ]

  // Map post categories
  const mapCategories = {}
  post?.metadata?.category?.forEach((c) => {
    mapCategories[c.slug] = true
  })

  // Filter all posts -exclude post and related_posts and include those that match their categories
  const _relatedPosts = posts?.filter(
    (p) => includesCategory(p, mapCategories) && !filter.includes(p.slug),
  )
  const relatedPosts = [
    ...(post?.metadata?.related_posts ?? []),
    ..._relatedPosts,
  ].slice(0, 6)

  return relatedPosts
}

export const getMainCategory = (post) => {
  if (post?.metadata?.category?.length > 1) {
    const _categories = post?.metadata?.category?.filter(
      (c) => c.slug !== 'most-popular-posts',
    )

    return {
      categoryTitle: _categories[0]?.title,
      categorySlug: _categories[0]?.slug,
    }
  }

  return {
    categoryTitle: post?.metadata?.category[0]?.title,
    categorySlug: post?.metadata?.category[0]?.slug,
  }
}
